import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Meeting} from "../../../shared/interface/meeting";
import {Regional} from "../../../shared/interface/regional";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute} from "@angular/router";
import {MeetingService} from "../../../shared/services/meeting.service";
import {RegionalService} from "../../../shared/services/regional.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-regional-details',
  templateUrl: './regional-details.component.html',
  styleUrls: ['./regional-details.component.scss']
})
export class RegionalDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  regionalId: string;
  regionalObject?: Regional;
  regional: ReplaySubject<Regional> = new ReplaySubject<Regional>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private regionalService: RegionalService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.regionalId = params.id;
        this.loadRegional();
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  loadRegional(): void {
    this.regionalService.get(this.regionalId).subscribe((regional: Regional) => {
      this.regional.next(regional);
      this.regionalObject = regional;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych regionalnego', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
